<template>
  <div class="card" @click="saveHistory">
    <div class="card-wrap van-hairline--bottom">
      <div class="main">
        <div class="content">
          <div class="title line-clamp-2" :class="{'title-sign': isBrowse}" style="font-size: 18px; line-height: 32px; max-height: 64px;">{{ news.name }}</div>
          <p class="description line-clamp-2">{{ news.description }}</p>
        </div>
        <img-lazy v-if="news.thumbnail" class="thumbnail" :src="news.thumbnail | thumbnail(220, 220)"/>
      </div>
      <div class="foot">
        <div class="data">
          <span class="item"><i class="iconfont icon-xin"></i>{{ news.like }}</span>
          <span class="item"><i class="iconfont icon-pinglun"></i>{{ news.comment }}</span>
          <span class="item"><i class="iconfont icon-shoucang_xuanzhongzhuangtai"></i>{{ news.view }}</span>
        </div>
        <div class="time"><i class="iconfont icon-shijian"></i>{{ news.createTime | formatTime }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import ImgLazy from '@/components/ImgLazy'
  import { saveBrowse, loadBrowse } from '@/utils/browseAuth'
  import { mapActions,mapState } from 'vuex'
  

  export default {
    name: "card-news",
    components: {ImgLazy},
    props: {
      news: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        isBrowse: false
      }
    },
    computed: {
      ...mapState([
        'browseHistory'
      ])
    },
    created() {
      let ishave = this.browseHistory.some((ele)=>{
        return ele === this.news.id
      })
      if(ishave){
        this.isBrowse = true
      }
    },
    methods: {
      saveHistory() {
        this.saveBrowsehHistory(this.news.id)
        this.isBrowse = true
      },
      ...mapActions([
        'saveBrowsehHistory'
      ])
    }
  }
</script>

<style lang="less" scoped>
  .card {
    padding: 0 20px;
  }

  .card-wrap {
    padding: 15px 0;
  }

  .main {
    display: flex;
    margin-bottom: 15px;
    height: 110px;
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .title {
    font-size: 18px;
    line-height: 32px;
    
    color: #000000;
    max-height: 64px;
    overflow: hidden;
  }
  
  .title-sign{
    color: #bcbfc0;
  }

  .description {
    // font-size: 12px;
    font-size:14px;
    line-height: 16px;
    color: #bcbfc0;
    max-height: 32px;
    margin-bottom: 5px;
  }

  .thumbnail {
    width: 110px;
    height: 110px;
    margin-left: 10px;
  }

  .foot {
    display: flex;
    justify-content: space-between;
    color: #9da0a3;
  }

  .data {
    .item {
      font-size: 12px;
      margin-right: 24px;
    }
    .iconfont {
      margin-right: 3px;
      font-size: 11px;
    }
  }

  .time{
    font-size: 12px;
    .iconfont{
      font-size: 11px;
    }
  }
</style>